import { produce } from 'immer'
import { create } from 'zustand'

type ApprovalFormState = {
	isFormValid: boolean
	formValues: Record<string, unknown>
}

type ApprovalFormActions = {
	actions: {
		clearFormValues: () => void
		setFormValues: (fieldName: string, value: unknown) => void
		setFormValidity: (isValid: boolean) => void
	}
}

const initialFormValues = {
	workloadClusterVersion: ''
}

const approvalFormStore = create<ApprovalFormState & ApprovalFormActions>(
	(set, _get) => ({
		isFormValid: false,
		formValues: initialFormValues,
		actions: {
			clearFormValues: () => set(() => ({ formValues: initialFormValues })),
			setFormValidity: (isValid: boolean) => set(() => ({ isFormValid: isValid })),
			setFormValues: (fieldName: string, value: unknown) =>
				set((state) =>
					produce(state, (draft) => {
						if (
							value &&
							typeof value === 'object' &&
							'value' in value
						) {
							draft.formValues[fieldName] = (value as { value: string }).value
						} else {
							draft.formValues[fieldName] = value
						}
					})
				)
		}
	})
)

export const useClusterApprovalFormStore = () =>
	approvalFormStore((state) => state)
